import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Self-contained shell + status badge for the PUBLIC Stripe-redirect landing
// pages. No auth / layout dependency — the paying client is not logged into the
// portal, so these live OUTSIDE every ProtectedRoute.

export function CheckoutShell({ children }: { children: ReactNode }) {
  return (
    <div className='flex min-h-screen items-center justify-center bg-muted/40 p-6'>
      <div className='flex w-full max-w-md flex-col items-center gap-3 rounded-2xl bg-background p-8 text-center shadow-lg'>
        {children}
      </div>
    </div>
  )
}

// Coloured circle that frames a status icon. Pass the lucide icon as children
// and the colour classes (bg + text) via `className`.
export function CheckoutStatusBadge({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div
      className={cn(
        'flex h-16 w-16 items-center justify-center rounded-full',
        className
      )}
    >
      {children}
    </div>
  )
}

export default CheckoutShell
